import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkExternal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13 3L16.293 6.293L9.29303 13.293L10.707 14.707L17.707 7.707L21 11V3H13Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19 19H5V5H12L10 3H5C3.897 3 3 3.897 3 5V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V14L19 12V19Z",
		fill: "currentColor"
	})]
});
export default SvgLinkExternal;
